import { NativeSelect } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { LOCALES, LOCALE_LABELS, isAppLocale, setAppLocale } from '../i18n';

export function LanguageSelector({ compact = false }: { compact?: boolean }) {
  const { t, i18n } = useTranslation('common');

  // `isAppLocale` is a type guard, so both arms are already AppLocale — the assertion this used to
  // carry told the compiler nothing it had not worked out.
  const current = isAppLocale(i18n.language) ? i18n.language : 'en-AU';

  return (
    <NativeSelect
      aria-label={t('language')}
      size={compact ? 'xs' : 'sm'}
      w={compact ? 118 : 140}
      value={current}
      data={LOCALES.map((code) => ({ value: code, label: LOCALE_LABELS[code] }))}
      onChange={(event) => {
        const next = event.currentTarget.value;
        if (isAppLocale(next)) {
          void setAppLocale(next);
        }
      }}
    />
  );
}
